import { render, staticRenderFns } from "./TemplateColumnSettings.vue?vue&type=template&id=5167531e&"
import script from "./TemplateColumnSettings.vue?vue&type=script&lang=js&"
export * from "./TemplateColumnSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5167531e')) {
      api.createRecord('5167531e', component.options)
    } else {
      api.reload('5167531e', component.options)
    }
    module.hot.accept("./TemplateColumnSettings.vue?vue&type=template&id=5167531e&", function () {
      api.rerender('5167531e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/TemplateManager/Components/Settings/TemplateColumnSettings.vue"
export default component.exports